import React from 'react'

interface OnResize {
  ({ width, height }: { width: number; height: number }): void
}

export function useScreenResize(onResize: OnResize): void {
  React.useEffect(() => {
    window.addEventListener('resize', () =>
      onResize({ width: window.innerWidth, height: window.innerHeight })
    )

    return function cleanup() {
      window.removeEventListener('resize', () =>
        onResize({ width: window.innerWidth, height: window.innerHeight })
      )
    }
  }, [onResize])
}
